import { ValidatorType } from "../types";

export const VALIDATORS: ValidatorType[] = [

  {
    id: "0x869bd71d03de95862aca3507131ddfd6922643b314d2175c29dd502cf6714d96",
    name: "",
    icon: "/assets/tokens/default_icon.png",
  },

  {
    id: "0x482a2049a2ca55eb9b4dd5818fea5f9aafcf1fc73494d6834771f505cfa35a0f",
    name: "Luganodes powered by Infrared",
    icon: "https://res.cloudinary.com/duv0g402y/image/upload/c_thumb,w_200,g_face/v1739968715/src/validators/mainnet/mzekeibmcpshwx0tqbyj.png",
  },

  {
    id: "0xb8a85d555aa2914ce56cc2f404894401c9821ce31d956e951589b912b1db55af",
    name: "",
    icon: "/assets/tokens/default_icon.png",
  },


  {
    id: "0x7627829f0b6b5368f296704e04119e4635f6fb6da1be61bf252bc5fba0e05695",
    name: "BicroStrategy",
    icon: "/assets/tokens/default_icon.png",
  },
  {
    id: "0x6b445ae600aff5c50403318485012783d9d04cd8c1ec9591998868220520857b",
    name: "wallahi",
    icon: "/assets/tokens/default_icon.png",
  },


  {
    id: "0x04cb1d078908f702fe8ab4d97182ad76fe07b0de2291a5351e4ab28b5e3ef5e1",
    name: "Frequency",
    icon: "https://res.cloudinary.com/duv0g402y/image/upload/c_thumb,w_200,g_face/v1739377904/src/validators/mainnet/lnyqzheabe7kseicovus.jpg",
  },


  {
    id: "0x1e31a4d3857962b302aa2e4e54740187c9870f8bebe8c10194e5a6bfcc965835",
    name: "",
    icon: "/assets/tokens/default_icon.png",
  },
  {
    id: "0x09127f1a822bf04c496172c0d38e9afc8ccc1b4e9fc4a8f6e9d0f1ff4fe6bc58",
    name: "",
    icon: "/assets/tokens/default_icon.png",
  },

];

export const BGT_ADDRESS = "0x656b95E550C07a9ffe548bd4085c72418Ceb1dba";
